"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var native_1 = tslib_1.__importDefault(require("./native"));
var constants_1 = require("../../../constants");
var defaultPlaybackAdapters = [
    native_1.default(constants_1.MediaStreamTypes.DASH, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    native_1.default(constants_1.MediaStreamTypes.HLS, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    native_1.default(constants_1.MediaStreamTypes.MP4, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    native_1.default(constants_1.MediaStreamTypes.WEBM, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    native_1.default(constants_1.MediaStreamTypes.OGG, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    native_1.default(constants_1.MediaStreamTypes.MOV, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    native_1.default(constants_1.MediaStreamTypes.MKV, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
];
exports.default = defaultPlaybackAdapters;
//# sourceMappingURL=default-set.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/playback-engine/adapters/default-set.js
// module id = 217
// module chunks = 0